import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  gridRow: {
    '&::after': {
      backgroundColor: 'transparent',
      bottom: 0,
      content: "''",
      height: '1px',
      left: 0,
      position: 'absolute',
      transform: 'translateX(-105%)',
      transition: `all ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeIn}`,
      width: '100%',
      zIndex: 10,
    },
    '&:hover, &:focus': {
      '& $itemTitle': {
        color: `rgb(${theme.palette.white})`,
      },
      outline: 0,
    },
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderBottom: `1px solid rgb(${theme.palette.mineShaft})`,
    display: 'flex',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    padding: '1rem',
    position: 'relative',
  },
  itemCategoryRank: {
    flex: 2,
    textAlign: 'right',
    [theme.breakpoints.up('sm')]: {
      flex: 1,
    },
  },
  itemCategoryRankHash: {
    fontFamily: theme.typography.secondary,
    fontSize: '1.1rem',
  },
  itemCategoryRankNo: {
    fontFamily: theme.typography.primary,
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  itemCategoryRankText: ({ categoryId }) => ({
    color: `rgba(var(--${categoryId}_rgb), 1)`,
    fontFamily: theme.typography.secondary,
    fontSize: '1.1rem',
    letterSpacing: '0.04rem',
  }),
  itemLink: {
    color: `rgb(${theme.palette.white})`,
    textDecoration: 'none',
  },
  itemRank: {
    '&:empty': {
      display: 'none',
    },
    '-webkit-text-stroke': `1px rgb(${theme.palette.gallery})`,
    color: 'transparent',
    flex: 1,
    fontFamily: theme.typography.primary,
    fontSize: '1.7rem',
    fontWeight: '700',
    transition: `-webkit-text-stroke ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    [theme.breakpoints.up('sm')]: {
      fontSize: '2.857rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0.5rem',
    },
  },
  itemRealLink: ({ categoryId }) => ({
    '&:hover, &:focus': {
      // @note[JSS] Cannot find references if passing Material-UI props
      '& .item--rank': {
        '-webkit-text-stroke': `1px rgba(var(--${categoryId}_rgb), 1)`,
      },
      '& .listCategory::after': {
        backgroundColor: `rgba(var(--${categoryId}_rgb), 1)`,
        transform: 'translateX(0)',
      },
    },
  }),
  itemTitle: {
    color: `rgb(${theme.palette.gallery})`,
    flex: 3,
    fontFamily: theme.typography.secondary,
    fontSize: '1.5rem',
    lineHeight: 1,
    paddingBottom: '3px',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    [theme.breakpoints.up('sm')]: {
      flex: 3,
      fontSize: '2.571rem',
    },
  },
  listImage: {
    '& + div': {
      opacity: 0,
      transform: 'translate3d(0, 25px, 0)',
      transition: `300ms all 300ms cubic-bezier(0.42, 0, 0.58, 1)`,
    },
    '&.lazy-load-image-loaded': {
      display: 'none !important',
    },
    '&.lazy-load-image-loaded + div': {
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
      transition: `300ms all 300ms cubic-bezier(0.42, 0, 0.58, 1)`,
    },
  },
}))

export default useStyles
